export default {
  production: process.env.NODE_ENV === 'production',
  // vue-ls options
  storageOptions: {
    namespace: 'c4m__', /* key prefix */
    name: 'ls', /* name variable Vue.[ls] or this.[$ls], */
    storage: 'local' /* storage name session, local, memory */
  }
}



// WEBPACK FOOTER //
// ./src/config/defaultSettings.js